/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.PackageTypes {
    "use strict";

    export class PackageTypesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        defaultPrepaidTip: number;
        packageTypeServiceDetail: Model.PackageTypeService;
        packageTypeProductDetail: Model.PackageItemDataDetail;
        packageTypeProductUnitDetail: Model.PackageProductUnitDataDetail;
        productUsageEnabled = false;
        mainSection: MainSection = null;
        private _egiftPackageUrl: string = undefined;

        public serviceCriteria = {
            packageServiceRedemption: null,
        };

        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            private roundingService: Meevo.Components.Common.IRoundingService,
            private $translate: angular.translate.ITranslateService,
            private $filter: angular.IFilterService,
            private $scope: angular.IScope
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.baseEndpoint = appSettings.API_ENDPOINTS.packageType;
            this.sectionTemplatePath = "app/plugins/packageTypes/sectionViews/";

            this.entityType = 'PackageType';
            this.initializeSections();
        }

        initializeSections(): void {
            this.dataService.customMethodData("api/tenant/businessInfo/settings", "GET", null).then((result: any) => {
                this.productUsageEnabled = result.data.generalSettings.productUsageTracking;
                
                this.serviceCriteria.packageServiceRedemption = this.productUsageEnabled
                    ? Meevo.Model.PackageServiceRedemptionEnum.Service
                    : null;
            })

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_PACKAGETYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.mainSection = new MainSection(0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    false,
                    this.appSettings.API_ENDPOINTS.packageType,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    this.roundingService,
                    this.modalService,
                    Model.NounEnum.PackageMain,
                    this.appSettings,
                    this.securityKeys.DATA_PACKAGETYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                );
                this.sections.push(this.mainSection);
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_PACKAGETYPE_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new CompensationSection(1,
                    'SECTION_EMPLOYEE_COMPENSATION',
                    'compensation.html',
                    false,
                    false,
                    this.baseEndpoint,
                    'Compensation',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.PackageCompensationTab,
                    this.modalService,
                    this.securityKeys.DATA_PACKAGETYPE_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_PACKAGETYPE_TAB_NOTIFICATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new NotificationsSection(2,
                    'SECTION_PACKAGE_NOTIFICATIONS',
                    'notifications.html',
                    false,
                    false,
                    this.baseEndpoint,
                    'Notifications',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.PackageCompensationTab,
                    this.modalService,
                    this.securityKeys.DATA_PACKAGETYPE_TAB_NOTIFICATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));
            }
        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_PACKAGETYPE_TAB_PAYROLL);
                    break;
                default:
                    this.buildCrudSecurityKeys(this.securityKeys.DATA_PACKAGETYPE_TAB_MAIN);
                    break;
            }
            super.selectSection(item);
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            this.defaultPrepaidTip = model.defaultPrepaidTip;
            this.updatedSelectedItemsList();
            this.eGiftProcess();
        }

        addService(): void {
            const packageType = this.castModel<Model.PackageType>();
            if (!packageType || !this.packageTypeServiceDetail) {
                return;
            }

            const serviceId = this.packageTypeServiceDetail.id;
            if (_.find(packageType.services, (ec) => ec.id === serviceId) === undefined) {
                const priceUri = `/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.service}/${serviceId}/price`;
                this.dataService.customMethodData(priceUri, 'GET', null).then(response => {
                    // Get price for selected service
                    this.packageTypeServiceDetail.fullItemPrice = response.data;
                    packageType.services.push(this.packageTypeServiceDetail);
                    this.packageTypeServiceDetail = undefined;
                    this.updatedSelectedServiceList();
                });
            }
        }

        addProduct(): void {
            const packageType = this.castModel<Model.PackageType>();
            if (!packageType || !this.packageTypeProductDetail) {
                return;
            }

            packageType.products.push(this.packageTypeProductDetail);
            this.packageTypeProductDetail = undefined;
            this.updatedSelectedProductList();
        }

        addProductUnit(): void {
            const packageType = this.castModel<Model.PackageType>();
            if (!packageType || !this.packageTypeProductUnitDetail) {
                return;
            }
            this.packageTypeProductUnitDetail.quantity = 1;
            this.dataService.customMethodData(`/api/product/${this.packageTypeProductUnitDetail.productId}/Usage`, "GET", {}).then((response) => {
                const settings = response.data.variantUsageSettings || [];
                const variantSetting = settings.find(setting => setting.id === this.packageTypeProductUnitDetail.id);

                let chargeAmount = !variantSetting || variantSetting.chargeType === Model.ProductVariantChargeTypeEnum.None ? 0 :
                    variantSetting.chargeAmount;
                this.packageTypeProductUnitDetail.fullItemPrice = chargeAmount;

                packageType.productUnits.push(this.packageTypeProductUnitDetail);
                this.packageTypeProductUnitDetail = undefined;
                this.updateSelectedProductUnitList();
            })

        }

        removeService(index: number): void {
            const packageType = this.castModel<Model.PackageType>();
            if (!packageType) {
                return;
            }

            packageType.services.splice(index, 1);

            if (packageType.services.length < 1) {
                packageType.isUnlimitedServices = false;
                packageType.isSplitSwappable = false;
                packageType.defaultPrepaidTip = 0;
                packageType.packageChargeAmount = 0;
            }

            this.updatedSelectedServiceList();
        }

        removeProduct(index: number): void {
            const packageType = this.castModel<Model.PackageType>();
            if (!packageType) {
                return;
            }

            packageType.products.splice(index, 1);

            this.updatedSelectedProductList();
        }

        removeProductUnit(index: number): void {
            const packageType = this.castModel<Model.PackageType>();
            if (!packageType) {
                return;
            }

            packageType.productUnits.splice(index, 1);

            this.updateSelectedProductUnitList();
        }

        updatedSelectedItemsList(): void {
            this.updatedSelectedServiceList();
            this.updatedSelectedProductList();
            this.updateSelectedProductUnitList();
        }

        updatedSelectedServiceList(): void {
            this.updatedSelectedItemList(Model.PackageItemTypeEnum.Service);
        }

        updatedSelectedProductList(): void {
            this.updatedSelectedItemList(Model.PackageItemTypeEnum.Product);
        }

        updateSelectedProductUnitList(): void {
            this.updatedSelectedItemList(Model.PackageItemTypeEnum.ProductUnit);
        }

        updatedSelectedItemList(packageItemType: Model.PackageItemTypeEnum): void {
            const packageType = this.castModel<Model.PackageType>();

            var items = [...packageType.products, ...packageType.services, ...packageType.productUnits];

            switch (packageItemType) {
                case Model.PackageItemTypeEnum.Product:
                    packageType.selectedProductList = _(packageType.products).map((product) => { return { id: product.id } });
                    break;
                case Model.PackageItemTypeEnum.ProductUnit:
                    packageType.selectedProductUnitList = _(packageType.productUnits).map((unit) => { return { id: unit.id } });
                    break;
                default:
                    packageType.selectedServiceList = _(packageType.services).map((service) => { return { id: service.id } });
                    if (packageType.services.length < 1) {
                        packageType.isUnlimitedServices = false;
                    }
                    break;
            }

            this.lineItemValueChanged(items);
        }

        orderItems(): void {
            const packageType = this.castModel<Model.PackageType>();
            if (!packageType) {
                return;
            }

            (packageType.services || []).forEach((service, index) => service.lineNumber = index);
            (packageType.products || []).forEach((product, index) => product.lineNumber = index);
            (packageType.productUnits || []).forEach((productUnit, index) => productUnit.lineNumber = index);
        }

        productPriceChanged(product: Model.PackageTypeProduct) {
            if (product.retail !== product.fullItemPrice) {
                product.retailOverride = product.fullItemPrice;
            }
            this.lineItemValueChanged();
        }

        lineItemValueChanged(items: Model.PackageTypeItem[] = null): void {
            const packageType = this.castModel<Model.PackageType>();
            items = items || [...packageType.services, ...packageType.products, ...packageType.productUnits];

            packageType.packageValue = 0;

            if (!items || items.length < 1) {
                return;
            }

            // Value calculation
            _.forEach(items, item => {
                // calculate PackageValue
                packageType.packageValue = this.roundingService.addNormalizedNumbers(packageType.packageValue, item.fullItemPrice * item.quantity);
            });
        }

        isMembershipOnlyChanged(): void {
            const packageType = this.castModel<Model.PackageType>();

            if (packageType.isMembershipOnly) {
                packageType.expireAfterPurchaseWeeks = 0;
                packageType.isGlobalPackage = false;
                packageType.isBookableOnline = false;
                packageType.packageChargeAmount = 0;
                packageType.isPackageChargePercent = false;
            }
        }

        isGlobalPackageChanged(): void {
            const packageType = this.castModel<Model.PackageType>();

            if (!!packageType.isGlobalPackage) {
                packageType.isLocationRestrictedRedemption = false;
            }
        }

        isUnlimitedChanged(isUnlimited: boolean): void {
            const packageType = this.castModel<Model.PackageType>();
            packageType.defaultPrepaidTip = isUnlimited ? 0 : this.defaultPrepaidTip;
        }

        save(): angular.IPromise<any> {

            if (this.selectedSection.sectionId !== 0) {
                return super.save();
            }

            this.orderItems();

            const packageType = this.castModel<Model.PackageType>();
            packageType.products.forEach(product => product.retail = product.fullItemPrice);

            if (packageType.packageChargeAmount <= 0 && packageType.isIncludePackageCharge == true) {
                this.modalService.alert("MESSAGE_PACKAGE_CHARGE_ZERO_AND_INCLUDE_PACKAGE_CHARGE_SELECTED");
            }
            else {
                if (packageType.packagePrice <= 0 && this.selectedSection.sectionId == 0) {
                    const meevoCurrency = this.$filter('meevoCurrency') as any;
                    const pkgAmount = meevoCurrency(packageType.packageChargeAmount);
                    const msgZeroValue = this.$translate.instant("MESSAGE_PACKAGE_ZERO_VALUE", { packageAmount: packageType.packagePrice });

                    this.modalService.alert(msgZeroValue, 0, true, {
                        showCancelButton: true,
                        okButtonContentKey: 'LABEL_YES',
                        cancelButtonContentKey: 'LABEL_NO',
                        cancelButtonHotKey: 'MODAL_NO_BUTTON',
                        okButtonHotKey: 'MODAL_YES_BUTTON'
                    }).then((confirmResult: boolean) => {
                        if (confirmResult) {
                            return super.save().then((data: any) => {
                                this.packageTypeServiceDetail = undefined;
                                this.updatedSelectedItemsList();
                                this.eGiftProcess();
                            });
                        }
                    }).catch((res: any | boolean) => {
                        if (res === false) {
                            $("#pkgPriceAmount input[type='text']").val('').focus();
                        }
                    });
                } else {
                    return super.save().then((data: any) => {
                        this.packageTypeServiceDetail = undefined;
                        this.updatedSelectedItemsList();
                        this.eGiftProcess();
                    });
                }
            }
        }

        postCopy(): void {
            super.postCopy();
            const model = this.castModel<Model.PackageType>();
            model.displayName = undefined;
        }

        copy(): void {
            const isPUTPackage = (this.mainSection && this.mainSection.isProductUsageTrackingPackage());
            if (isPUTPackage && !this.productUsageEnabled) {
                this.modalService.message("MESSAGE_PACKAGE_COPY_NOT_ALLOWED");
            }
            else {
                super.copy();
            }
        }

        isCopyStyledAsDisabled(): boolean {
            const isPUTPackage = (this.mainSection && this.mainSection.isProductUsageTrackingPackage());
            const styleAsDisabled = (isPUTPackage && !this.productUsageEnabled);
            if (styleAsDisabled) {
                return styleAsDisabled;
            }
            return super.isCopyStyledAsDisabled();
        }
        get egiftPackageUrl(): string {
            return this._egiftPackageUrl;
        }

        set egiftPackageUrl(value: string) {
            this._egiftPackageUrl = value;
        }

        eGiftProcess() {
            this.dataService.customMethodData("api/Settings/EGifts", "GET", null)
                .then((result: any) => {
                    if (!result || !result.data || (!result.data.requireClientToSelectLocation && result.data.locationId != this.identityService.current().locationId) )
                        return;

                    this.dataService.customMethodData("api/tenant/businessinfo/customerportalurl", "GET", null)
                        .then((result: any) => {
                            if (result && result.data && result.data.eGiftUrl) {
                                this.egiftPackageUrl = result.data.eGiftUrl;
                            }
                            this.egiftPackageUrl += `&packageId=${this.selectedSection.model.id}`;
                        });
                });
        }

        get decimalRoundingDigits(): number {
            const identity = this.identityService.current();
            const digits = identity.decimalPositions;
            return digits;
        }

    }
}